import { Card, Skeleton } from '@mui/material';
import { CardContent, CourseContent, ImageWrapper } from './CourseCard';
import Spacing from './Spacing';

export type CourseCardSkeletonProps = {
  isVertical?: boolean;
};

export default function CourseCardSkeleton({ isVertical = false }: CourseCardSkeletonProps) {
  return (
    <Card>
      <CardContent isVertical={isVertical}>
        <ImageWrapper isVertical={isVertical}>
          <Skeleton variant="rectangular" sx={{ height: '100%' }} />
        </ImageWrapper>
        <CourseContent>
          <Spacing y={1}>
            <Skeleton variant="text" sx={{ width: '50%' }} />
            <Skeleton variant="text" sx={{ fontSize: 14 }} />
            <Skeleton variant="text" sx={{ fontSize: 14 }} />
            <Skeleton variant="text" sx={{ fontSize: 14 }} />
          </Spacing>
        </CourseContent>
      </CardContent>
    </Card>
  );
}
